import { Box, TextField, Typography, getContrastRatio } from "@mui/material";
import CustomAlert from "../../events/components/CustomAlert"
import { useDispatch, useSelector } from "react-redux";
import CheckIcon from "../../../components/icons/CheckIcon";
import { generateLighterContrastColor} from "../../../utils/commonServices";
import useCustomTheme from "../../../theme/useCustomTheme";
import { updateProjectState } from "../../../redux/projectSlice";
import usePermissions from "../../../hooks/usePermissions";
import {  useState } from "react";





const ViewNotesToEditorPopup = ({event}) => {
    const dispatch = useDispatch()
    const commonReducer = useSelector((state) => state.root.commonReducer);
    const projectReducer = useSelector((state) => state.projectReducer);
    const teamsReducer = useSelector((state) => state.root.teamsReducer);
    const [theme] = useCustomTheme()
    // const inputRef = useRef(null);
    const [hasPermission] = usePermissions()
    const [editMode, setEditMode] = useState(false)
    const [description, setDescription] = useState(projectReducer?.project_details?.description)
  
 


    const handleClose = () => {
      dispatch(updateProjectState({view_notes_to_editor_popup : false}))      
    };

 



    return (
        <CustomAlert 
          open={projectReducer.view_notes_to_editor_popup} 
          handleClose={handleClose} 
          height={{xs:'550px',md:'520px',lg:'530px' ,xl:'740px'}}
          // height={{xs:'550px',md:'610px',lg:'605px' ,xl:'700px'}}
          width={{xs:'600px',md:'700px',lg:'740px',xl:'1130px'}}
          >       
            <Box sx={{display:'flex', flexDirection:'column', height:'100%'}} px={4} pt={{xs:5,sm:3, md:4, lg:5, xl:6}} pb={2}>
          
                 
                  <Box className='flex col' gap={{xs:0.5, lg:1}}  sx={{ height:'100%'}}>
                    <Box className='flex j-between a-center' mb={2} style={{width:{xs:'90%', md:'80%'}}}>
                      <Typography sx={{fontWeight:600, fontFamily:'Rubik', color:'#000', fontSize:{xs:'14px',sm:'14px',md:'16px',lg:'20px',xl:'30px'}}}>View Notes</Typography>
                      <Box className='flex a-center j-end' gap={2}>
                      {/* {editMode &&
                        <CustomButton 
                        btnText={'Cancel'}
                        onClick={convertToViewMode}
                        type='button'    
                        color='secondary'
                        variant='outlined'
                        style={{
                          borderRadius: '5px',
                          border: "none",
                          textTransform:'none',
                        }}
                        sx={{fontSize:{xs:'9px',sm:'10px',lg:'12px',xl:'18px'},  fontWeight:600, height:{xs:'22px',sm:'24px',lg:'28px',xl:"40px"}, width: '100%', maxWidth: {xs:'120px', xl:'180px'} , fontFamily:'Rubik'}}
                      />
                      } */}
                      {/* {( hasPermission(PERMISSION.PROJECT.INFO.EDIT) &&  (commonReducer?.event_details?.status_type_order < 3) ) &&  <LoadingButton
                        onClick={editMode ? saveEditNoteDescription : convertToEditMode}
                        type='button'    
                        color='secondary'
                        variant='contained'
                        loading={projectReducer?.is_loading}
                        loadingPosition="end"
                        style={{
                          borderRadius: '5px',
                          border: "none",
                          textTransform:'none',
                        }}
                        disabled={editMode && description?.length  === 0}
                        endIcon={editMode ? <SaveOutlinedIcon style={{fontSize:'15px'}} /> : <EditOutlinedIcon style={{fontSize:'15px'}} />}
                        sx={{fontSize:{xs:'9px',sm:'10px',lg:'12px',xl:'18px'},  fontWeight:600, height:{xs:'22px',sm:'24px',lg:'28px',xl:"40px"}, width: '100%', maxWidth: {xs:'120px', xl:'180px'} , fontFamily:'Rubik'}}
                      >{editMode ? 'Save' : 'Edit'}</LoadingButton>
                      } */}

                      </Box>
                      
                    </Box>
        

                       
                        <Box className='flex' flex={1} sx={{ overflowY:'auto', }} >
                        {projectReducer?.project_details?.description &&   (
                                <Typography style={{ whiteSpace: "pre-line" }}   sx={{mt:0.5}}>{projectReducer?.project_details?.description}</Typography>
                             )}
                           
                         
                          
                           
                  
                        </Box>
                        <Box  className='flex j-end a-end'  mt={1}>
                           <CheckIcon onClick={ handleClose}  color={theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' :  getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main)}  sx={{fontSize:{xs:'28px',sm:'30px',md:'42px', lg:'56px',xl:'75px'}, cursor:  'pointer', }}/>
                        </Box>
                  </Box>
  
             
          </Box>
       
        </CustomAlert>
      )
}

export default ViewNotesToEditorPopup

